import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap-5';

import { setFilterAttribute } from 'bundles/connect/components/store/actions/criteria';
import type { Criteria } from 'bundles/connect/types';

type TextInputProps = {
  attribute: string;
  criteria: Criteria;
  disabled?: boolean;
  maxLength?: number;
  placeholder?: string;
  setFilterAttribute: (attribute: string, value: string | null, options?: any) => { type: string } | undefined;
  type?: string;
}

function TextInput({
  criteria,
  attribute,
  placeholder,
  setFilterAttribute,
  type,
  disabled = false,
  maxLength,
}: TextInputProps) {
  return (
    <Form.Control
      className={criteria[attribute] ? 'active' : ''}
      disabled={disabled}
      maxLength={maxLength}
      placeholder={placeholder}
      type={type ? type : 'text'}
      value={criteria[attribute] || ''}
      onChange={e => setFilterAttribute(attribute, e.target.value)}
    />
  );
}

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(TextInput);
